"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yellow600 = exports.yellow700 = exports.green50 = exports.green100 = exports.green200 = exports.green300 = exports.green400 = exports.green500 = exports.green600 = exports.green700 = exports.blue50 = exports.blue100 = exports.blue200 = exports.blue300 = exports.blue400 = exports.blue500 = exports.blue600 = exports.blue700 = exports.lilac50 = exports.lilac100 = exports.lilac200 = exports.lilac300 = exports.lilac400 = exports.lilac500 = exports.lilac600 = exports.lilac700 = exports.pink50 = exports.pink100 = exports.pink200 = exports.pink300 = exports.pink400 = exports.pink500 = exports.pink600 = exports.pink700 = exports.red50 = exports.red100 = exports.red200 = exports.red300 = exports.red400 = exports.red500 = exports.red600 = exports.red700 = exports.purple50 = exports.purple100 = exports.purple200 = exports.purple300 = exports.purple400 = exports.purple500 = exports.purple600 = exports.purple700 = void 0;
exports.inactiveGray = exports.notificationBlue = exports.accentBlue = exports.accentYellow = exports.accentPink = exports.white = exports.gray50 = exports.gray100 = exports.gray200 = exports.gray300 = exports.gray400 = exports.gray500 = exports.gray600 = exports.gray700 = exports.gray800 = exports.black = exports.orange50 = exports.orange100 = exports.orange200 = exports.orange300 = exports.orange400 = exports.orange500 = exports.orange600 = exports.orange700 = exports.yellow50 = exports.yellow100 = exports.yellow200 = exports.yellow300 = exports.yellow400 = exports.yellow500 = void 0;
exports.purple700 = '#2B0840';
exports.purple600 = '#32064C';
exports.purple500 = '#410861';
exports.purple400 = '#48096C';
exports.purple300 = '#6D3A89';
exports.purple200 = '#916BA7';
exports.purple100 = '#DACEE2';
exports.purple50 = '#EDE6F0';
exports.red700 = '#480610';
exports.red600 = '#900C20';
exports.red500 = '#BE1807';
exports.red400 = '#ED0B09';
exports.red300 = '#F1453A';
exports.red200 = '#F4736B';
exports.red100 = '#FABCB5';
exports.red50 = '#FDE9E6';
exports.pink700 = '#CC7970';
exports.pink600 = '#FF978C';
exports.pink500 = '#FFB6AF';
exports.pink400 = '#FFD2BD';
exports.pink300 = '#FFE0D1';
exports.pink200 = '#FFE9DE';
exports.pink100 = '#FFF6F2';
exports.pink50 = '#FFFBF8';
exports.lilac700 = '#A09EB0';
exports.lilac600 = '#B7B5C9';
exports.lilac500 = '#CECBE2';
exports.lilac400 = '#E5E2FB';
exports.lilac300 = '#EAE8FC';
exports.lilac200 = '#EDEBFC7';
exports.lilac100 = '#F7F5FD';
exports.lilac50 = '#F6F7F9';
exports.blue700 = '#102C60';
exports.blue600 = '#174291';
exports.blue500 = '#1E54B7';
exports.blue400 = '#1A65F0';
exports.blue300 = '#5B91F5';
exports.blue200 = '#A0BFF8';
exports.blue100 = '#D4E2FC';
exports.blue50 = '#EFF3FE';
exports.green700 = '#0B3429';
exports.green600 = '#166852';
exports.green500 = '#1E8B6D';
exports.green400 = '#25AE88';
exports.green300 = '#51BEA0';
exports.green200 = '#7CCEB8';
exports.green100 = '#A8DFCF';
exports.green50 = '#E9F7F3';
exports.yellow700 = '#806022';
exports.yellow600 = '#B3862F';
exports.yellow500 = '#CC9A36';
exports.yellow400 = '#FFC043';
exports.yellow300 = '#FFCF70';
exports.yellow200 = '#FFE3AC';
exports.yellow100 = '#FFF2D9';
exports.yellow50 = '#FFFAF0';
exports.orange700 = '#7D2714';
exports.orange600 = '#AE371C';
exports.orange500 = '#CC492C';
exports.orange400 = '#FF6937';
exports.orange300 = '#FA9269';
exports.orange200 = '#FABDA5';
exports.orange100 = '#FFE1D6';
exports.orange50 = '#FFF3EF';
exports.black = '#000000';
exports.gray800 = '#1E1E1E';
exports.gray700 = '#302F2F';
exports.gray600 = '#4B4B4B';
exports.gray500 = '#787878';
exports.gray400 = '#A0A0A0';
exports.gray300 = '#C7C3C3';
exports.gray200 = '#E0DEDE';
exports.gray100 = '#F0EDED';
exports.gray50 = '#F8F8F8';
exports.white = '#FFFFFF';
exports.accentPink = '#FFC5EE';
exports.accentYellow = '#F9FF4E';
exports.accentBlue = '#88FDFF';
exports.notificationBlue = '#276EF1';
exports.inactiveGray = '#A9AA9';
//# sourceMappingURL=colors.js.map